import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Chip,
	Accordion,
	AccordionSummary,
	AccordionDetails,
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
	ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Tabs } from "../../components/tabs";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { receiveUsers } from "../../../state/user/actions";
import { Notice } from "../../components/notice";
import Profile from "./profile";

const API_HOST = CONFIG.modules["accounts"].host;

const items = {
	Employees: {
		name: "Employees",
		view: "",
	},
};

const fields = [
	{
		type: "text",
		label: "Name",
		required: true,
		name: "name",
	},
	{
		type: "select",
		label: "Gender",
		option: { key: "genders", value: "_id", label: "name" },
		required: true,
		name: "gender",
	},
	{
		type: "date",
		label: "Birthday",
		required: true,
		name: "dob",
		defaultValue: dayjs(),
	},
	{
		type: "text",
		label: "Phone",
		required: true,
		name: "phone",
	},
	{
		type: "text",
		label: "Email",
		required: true,
		name: "email",
	},
	{
		type: "password",
		label: "Password",
		required: true,
		name: "password",
	},
	{
		type: "textArea",
		label: "Permanent Address",
		required: true,
		name: "permanentAddress",
	},
	{
		type: "textArea",
		label: "Current Address",
		required: true,
		name: "currentAddress",
	},


];

const emergencyContactfields = [
	{
		type: "text",
		label: "Name",
		required: true,
		name: "emergencyContactName",
	},
	{
		type: "text",
		label: "Relation",
		required: true,
		name: "emergencyContactRelation",
	},
	{
		type: "text",
		label: "Contact Number",
		required: true,
		name: "emergencyContactNumber",
	},
];

const employementDetails = [
	{
		type: "date",
		label: "Date of Joining",
		required: true,
		name: "dateOfJoining",
		defaultValue: dayjs(),
	},
	{
		type: "select",
		label: "Departments",
		option: { key: "Departments", value: "_id", label: "name" },
		required: true,
		name: "departments",
		multiple: true,
	},
	// {
	// 	type: "select",
	// 	label: "Designation",
	// 	option: { key: "Designations", value: "_id", label: "name" },
	// 	required: true,
	// 	name: "designation",
	// 	multiple: true,
	// },
	{
		type: "select",
		label: "Designation",
		option: { key: "roles", value: "_id", label: "name" },
		required: true,
		name: "roles",
		multiple: true,
	},
	{
		type: "select",
		label: "Assigned Roles",
		option: { key: "TaskTypes", value: "_id", label: "name" },
		required: true,
		name: "assignedRoles",
		multiple: true,
	},
	{
		type: "select",
		label: "Add Languages",
		option: { key: "Languages", value: "_id", label: "name" },
		name: "languages",
		multiple: true,
	},
	{
		type: "select",
		label: "Employement Type",
		option: { key: "employementTypes", value: "_id", label: "name" },
		required: true,
		name: "employementType",
	},

];

const authorisationHierarchy = [
	{
		type: "switch",
		label: "Is PMU",
		name: "isPMU",
		defaultValue: false,
	},
	{
		type: "switch",
		label: "Leave for POC",
		name: "leaveForPOC",
		defaultValue: false,
	},
	{
		type: "select",
		label: "Reporting Manager",
		option: { key: "rms", value: "_id", label: "name" },
		name: "reportingManager",
	},
	{
		type: "select",
		label: "POC",
		option: { key: "pocs", value: "_id", label: "name" },
		name: "pocForLeaves",
	},
];

const ozonetelDetails = [
	{
		type: "text",
		label: "Agent ID",
		required: true,
		name: "agentId",
	},
];

export const EditEmployee = ({ saved, onClose, openIt, openDelete, onCloseDelete }) => {
	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
		TaskTypes,
		map,
	} = useSelector((state) => state.user || {});
	const userStore = useSelector((state) => state.user || {});

	const history = useHistory();
	const dispatch = useDispatch();

	const [DepartmentsFiltered, setDepartmentsFiltered] = useState([]);
	const [active, setActive] = useState("");
	const [action, setAction] = useState("edit");
	const [index, setIndex] = useState(null);
	const [openConfirm, setOpenConfirm] = useState(false);
	const [open, setOpen] = useState(false)

	const [formData, setFormData] = useState(
		getFormState([
			...fields,
			...employementDetails,
			...authorisationHierarchy,
			...emergencyContactfields,
		])
	);

	const [savedMessage, setSavedMessage] = useState(false);

	useEffect(() => {

	}, [DepartmentsFiltered]);

	useEffect(() => {
	}, [users]);

	useEffect(() => {

	}, [formData.department_type]);

	useEffect(() => {
	}, [formData]);

	useEffect(() => {
		console.log('Edit open', openIt)
		if (openIt) {
			onClickEdit()
		}
	}, [openIt])

	// useEffect(()=> {
	// 	onClickEdit()
	// }, [])

	useEffect(() => { }, [active]);

	useEffect(() => { }, [Designations]);

	useEffect(() => { }, [userStore]);


	const handleEdit = () => {
		if (formData.password == "") {
			delete formData.password;
		}
		const toSave = { ...formData };

		axios
			.put(API_HOST + `/${saved._id}`, {
				user: toSave,
			})
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setOpen(false);

					const newUsers = [...users]
					const index = newUsers.findIndex(u => u._id == saved._id)
					if (index > -1)
						newUsers[index] = resp.data.user;

					dispatch(receiveUsers(newUsers));
					setSavedMessage("Great! Employee Saved");

					setTimeout(() => {
						setSavedMessage(null);
					}, 2000);
				}
				onClose()
			})
			.catch((e) => {
				console.log(e);
				onClose()
			});
	};



	const [profieData, setProfileData] = useState("");
	const [openProfile, setOpenProfile] = useState(false);


	const handleEditForm = (id) => {
		console.log("edit", id);
	};

	const onClickEdit = () => {

		const newData = { ...saved };
		console.log('new-data', newData)
		newData.password = "";
		newData.dob = dayjs(newData.dob);
		newData.dateOfJoining = dayjs(newData.dateOfJoining);
		if (newData.departments) {
			console.log('hello', newData.departments)
			newData.departments = newData.departments.map((d) => {
				console.log('mango', d)
				return d._id
			}
			);
		}
		if (newData.designation) {
			newData.designation = newData.designation.map((d) => d._id);
		}
		if (newData.assignedRoles) {
			newData.assignedRoles = newData.assignedRoles.map((d) => d._id);
		}
		setFormData(newData);
		setAction("edit");
		// setOpen(true);
		setOpenProfile(false);
	};



	const handleDelete = () => {
		axios
			.delete(API_HOST + "/" + saved._id)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setOpenConfirm(false);
					let data = users
					const index = data.findIndex(u => u._id == saved._id)
					if (index > -1)
						data.splice(index, 1);
					dispatch(receiveUsers([...data]));
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<>


			{savedMessage && <Notice text={savedMessage} />}

			<Modal
				open={openIt}
				handleClose={() => {
					// setOpen(false);
					onClose()
				}}
				head={`${action == "new" ? "New Employee Data" : "Editbbbb"} ${active}`}
				buttons={[
					{
						name: "Cancel",
						onClick: () => {
							// setOpen(false);
							if (window.confirm("Are you sure you want to cancel?")) {
								setSavedMessage("Employee Data not created!");
								setTimeout(() => {
									setSavedMessage(null);
								}, 2000);
								setOpen(false);
								onClose()
							}
						},
					},
					{
						name: action == "new" ? "Create" : "Save",
						onClick: () => {
							switch (action) {

								case "edit":
									setDepartmentsFiltered(
										(Departments || []).filter(
											(e) => e.type == formData.department_type
										)
									);
									handleEdit();
									break;
								default:
									break;
							}
						},
					},
				]}
			>
				{action == "edit" && (
					<Typography variant="p" color="grey">
						{"ID: " + saved._id}
					</Typography>
				)}
				{Array.isArray(fields) && (
					<>
						<Accordion defaultExpanded={true}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography>Personal Details</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<FormA
									fields={fields}
									data={{
										genders: [
											{
												_id: "male",
												name: "Male",
											},
											{
												_id: "female",
												name: "Female",
											},
										],
									}}
									onChange={(name, value, multiple) => {
										formData[name] = value;
										// if (name == "department_type") {
										// 	setFormData({ ...formData, departments: [] });
										// } else {
										// 	setFormData({ ...formData });
										// }
										setFormData({ ...formData });
									}}
									state={formData || {}}
								/>
								<Typography>Emergency Contact Person</Typography>
								<FormA
									fields={emergencyContactfields}
									onChange={(name, value, multiple) => {
										formData[name] = value;
										setFormData({ ...formData });
									}}
									state={formData || {}}
								/>
							</AccordionDetails>
						</Accordion>

						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography>Employment Details</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<FormA
									fields={employementDetails}
									data={{
										roles,
										Designations,
										Districts,
										Languages,
										Departments,
										DepartmentsFiltered,
										users,
										TaskTypes,
										department_types: [
											{
												_id: "Core",
												name: "Core",
											},
											{
												_id: "Project Based",
												name: "Project Based",
											},
										],
										employementTypes: [
											{
												_id: "Full Time",
												name: "Full Time",
											},
											{
												_id: "Part Time",
												name: "Part Time",
											},
										],
									}}
									onChange={(name, value, multiple) => {
										// console.log(name, value)
										formData[name] = value;
										// if (name == "department_type") {
										// 	setFormData({ ...formData, departments: [] });
										// } else {
										setFormData({ ...formData });
										// }
									}}
									state={formData || {}}
								/>
							</AccordionDetails>
						</Accordion>

						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography>Authorisations and Hierarchy</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<FormA
									fields={authorisationHierarchy}
									data={{
										users,
										TaskTypes,
										pocs: (users || []).filter((u) => u.leaveForPOC),
										rms: (users || []).filter((u) => u.isPMU),
									}}
									onChange={(name, value, multiple) => {
										// console.log(name, value)
										formData[name] = value;
										setFormData({ ...formData });
									}}
									state={formData || {}}
								/>
							</AccordionDetails>
						</Accordion>

						{/* For Ozontel Details */}

						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography>Ozonetel Details</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<FormA
									fields={ozonetelDetails}
									onChange={(name, value, multiple) => {
										formData[name] = value;
										setFormData({ ...formData });
									}}
									state={formData || {}}
								/>
							</AccordionDetails>
						</Accordion>

						{/* End Ozonetel Details */}
					</>
				)}
			</Modal>

			<Modal
				open={openDelete}
				handleClose={() => {
					onCloseDelete()
				}}
				head={`${"Delete"} user`}
				desc={`Please confirm to delete the following user?`}
				buttons={[
					{
						name: "Cancel",
						onClick: () => {
							onCloseDelete()
						},
					},
					{
						name: "Delete",
						onClick: () => {
							handleDelete();
						},
					},
				]}
			>
				{saved && (
					<Box>
						<Typography variant="p" color="grey">
							{"ID: " + saved._id}
						</Typography>
						<br></br>
						<Typography variant="p" color="grey">
							{"Name: " + saved.name}
						</Typography>
					</Box>
				)}
			</Modal>


		</>
	);
};
